<template>
<el-dialog
  title="生成报告"
  :visible.sync="visible"
  :append-to-body="true"
  custom-class="custom-dialog"
  width="378px"
>
  <div class="date-select-group">
    <div>
      <label>开始时间</label>

      <el-date-picker
        v-model="beginTime"
        :picker-options="startDatePickerOptions"
        :clearable="false"
        :editable="false"
        placeholder="开始时间"
        type="datetime"
        format="yyyy年MM月dd日HH时"
        value-format="yyyy/MM/dd HH:00:00"
      />
    </div>

    <div>
      <label>结束时间</label>

      <el-date-picker
        v-model="endTime"
        :picker-options="endDatePickerOptions"
        :clearable="false"
        :editable="false"
        placeholder="结束时间"
        type="datetime"
        format="yyyy年MM月dd日HH时"
        value-format="yyyy/MM/dd HH:59:59"
      />
    </div>
  </div>

  <template slot="footer">
    <el-button type="orange" style="width:100px;" @click="onOkBtnClick">确定</el-button>
    <el-button style="width:100px;" @click="onCancelBtnClick">取消</el-button>
  </template>
</el-dialog>
</template>

<script>
import BaseStore from '../../../../components/BaseStore'

export default {
  name: 'Creator',
  extends: BaseStore,
  data: () => {
    const date = new Date()
    date.setDate(date.getDate() - 1)
    return {
      visible: false,
      beginTime: date.format('YYYY/MM/DD 00:00:00'),
      endTime: date.format('YYYY/MM/DD 23:59:59')
    }
  },
  computed: {
    startDatePickerOptions () {
      return {
        disabledDate: time => this.endTime && time.getTime() > new Date(this.endTime)
      }
    },
    endDatePickerOptions () {
      return {
        disabledDate: time => this.beginTime && time.getTime() < new Date(this.beginTime)
      }
    }
  },
  methods: {
    open () {
      this.visible = true
    },
    close () {
      this.visible = false
    },
    onReportReceived (data) {
      this.close()
      this.$emit('report-created', data)
    },
    onOkBtnClick () {
      this.changeLoadStatus(true)
      const query = {
        beginTime: this.beginTime,
        endTime: this.endTime
      }
      this.$api.WordReport.checkPollution(query).then(data => {
        if (data.exist) {
          this.$confirm(`该时间段已有报告, 是否重新生成报告？`, '确认', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            confirmButtonClass: 'confirm-dialog-confirm-btn',
            cancelButtonClass: 'confirm-dialog-cancel-btn',
            type: 'warning'
          }).then(() => {
            this.changeLoadStatus(true)

            this.$api.WordReport.createPollutionProcessReport(query).then(this.onReportReceived).catch(console.error).finally(() => {
              this.changeLoadStatus(false)
            })
          }).catch(() => {})
        }

        return new Promise(resolve => resolve(data))
      }).then(this.onReportReceived).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    onCancelBtnClick () {
      this.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.date-select-group {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 22px;

  > * {
    display: grid;
    grid-template-columns: repeat(2, max-content);
    grid-column-gap: 10px;
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/06Data-Management/03Report/02PollutionProcess/Creator.vue